import React from "react";
import {useTranslation} from "react-i18next";
// local
import FormikField from "components/FormikField";

export const SignContractProfileField = (props) => {
  const {t} = useTranslation();

  return (
    <FormikField
      tiny
      uppercaseLabel
      boldLabel
      flatView
      className="input pl-1"
      style={{minWidth: "20px"}}
      {...props}
      label={t(props.label)}
      errorName={props.name}
      placeholder={t(props.placeholder)}
      addClass={props.addClass ?? "mb-2"}
    />
  );
};
